import { errorMessage } from "@components/forms/error";
import * as yup from "yup";

export const balanceChangeSchema = yup.object().shape({
  add_balance: yup.number().required(errorMessage.required),
  balance_type: yup.string().required(errorMessage.required).trim(),
  current_balance: yup.number().required(errorMessage.required),
  final_balance: yup.number().required(errorMessage.required),
  user: yup.string().required(errorMessage.required).trim(),
  comment: yup.string().required().trim(),
  type: yup.string().trim(),
});
